import type { LayeredConstructionCatalogItem, LayeredConstructionCatalogTableRow } from "../model/types";

import { buildLayerRows } from "./layers";

export const mapCatalogToTableData = (
  items: LayeredConstructionCatalogItem[]
): LayeredConstructionCatalogTableRow[] =>
  items.map((item) => {
    const layers = buildLayerRows(item);
    return {
      ...item,
      layerCount: layers.length,
      layers,
    };
  });
